(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Connexion', Connexion);

    Connexion.$inject = ['$resource'];

    function Connexion ($resource) {
        var resourceUrl =  'api/connexions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'create': { method: 'POST' },
            'update': { method:'PUT' },
            'internalNetworkCommercial': {
                url: '/api/connexions/internalnetwork/commercial/:profileId?size=50',
                isArray: true,
                method: 'GET'
            },
            'internalNetworkDG': {
                url: '/api/connexions/internalnetwork/dg/:profileId',
                isArray: true,
                method: 'GET'
            },
            'externalNetwork': {
                url: '/api/connexions/externalnetwork/:profileId',
                isArray: true,
                method: 'GET'
            },
            'allInternalNetworkCommercial': {
                url: '/api/connexions/internalnetwork/commercial',
                isArray: true,
                method: 'GET'
            },
            'allInternalNetworkDG': {
                url: '/api/connexions/internalnetwork/dg',
                isArray: true,
                method: 'GET'
            },
            'allInternalNetworkDGInvited': {
                url: '/api/connexions/internalnetwork/dg/invited',
                isArray: true,
                method: 'GET'
            },
            'allInternalNetworkDGArchived': {
                url: '/api/connexions/internalnetwork/dg/archived',
                isArray: true,
                method: 'GET'
            },
            'inverseNetworks': {
                url: '/api/connexions/inverseNetworks/:profileId',
                isArray: true,
                method: 'GET'
            },
            'search': {
                url: '/api/connexions/network/search/:query',
                isArray: true,
                method: 'GET'
            },
            'internalNetworkOfOrganisation': {
                method: 'GET',
                isArray: true,
                url: '/api/connexions/internalnetworkorganisation?organizationId=:organizationId&size=50'
            }

        });
    }
})();
